import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
	Button,
	LoadingComponent,
	Modal,
	Select,
} from "../../../components/core";
import { useDispatch, useSelector } from "react-redux";
import { NumericFormat } from "react-number-format";
import {
	useApolloClient,
	useLazyQuery,
	useMutation,
	useQuery,
} from "@apollo/client";
import StorageFeeTable from "./components/storage-fee-table";
import OverstayCharge from "./components/overstay-charge";
import MaxOverstayCharge from "./components/max-overstay-charge";
import {
	DOOR_SIZES_FOR_LOCKER_STORAGE_FEES,
	LOCKER_TYPE_FOR_LOCKER_STORAGE_FEES,
	STORAGE_SIZE_FEE,
	STORAGE_TIME_FEES,
	UPDATE_STORAGE_SIZE_FEE,
	UPDATE_STORAGE_TIME_FEE,
	USER_TYPE_FOR_LOCKER_STORAGE_FEES,
} from "../../../constants/graphql/locker-storage-fees-query";
import {
	addStorageTimeFeeForm,
	changeCriteriaValue,
	changeStorageSizeFeeData,
	changeStorageTimeFeeData,
	changeStorageTimeFeeForm,
	clearStorageTimeFeeForm,
	getDoorSizesList,
	getLockerTypeList,
	getUserTypeList,
	setStorageSizeFeeData,
	setStorageTimeFeeData,
} from "../../../features/locker-storage-fees/locker-storage-fees-slice";
import useSidebarStore from "../../../zustand/stores/sidebar-store";
import { useNavigate } from "react-router-dom";
import { Strings } from "../../../constants/strings";
function areAllFieldsNotMinusOne(obj) {
	// Get an array of the object's values
	const values = Object.values(obj);

	// Check if all values are not equal to -1
	return values.every((value) => value !== "-1");
}
function areAllfieldsNotEmpty(arr) {
	let flag = false;
	arr.forEach((element) => {
		const values = Object.values(element);
		if (values.every((value) => value !== "")) {
			flag = true;
		} else {
			flag = false;
		}
	});
	return flag;
}
export default function LockerStorageFees() {
	const client = useApolloClient();
	const navigate = useNavigate();
	// Utils
	const dispatch = useDispatch();
	// Redux States
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	const searchCriteria = useSelector(
		(state) => state.lockerStorageFees.searchCriteria
	);
	const storageSizeFeeData = useSelector(
		(state) => state.lockerStorageFees.storageSizeFeeData
	);
	const storageTimeFeeData = useSelector(
		(state) => state.lockerStorageFees.storageTimeFeeData
	);
	const storageTimeFeeForm = useSelector(
		(state) => state.lockerStorageFees.storageTimeFeeForm
	);
	const userTypeList = useSelector(
		(state) => state.lockerStorageFees.userTypeList
	);
	const lockerTypeList = useSelector(
		(state) => state.lockerStorageFees.lockerTypeList
	);
	const doorSizesList = useSelector(
		(state) => state.lockerStorageFees.doorSizesList
	);
	// zustand
	const pendingNavigation = useSidebarStore((state) => state.pendingNavigation);
	const setPendingNavigation = useSidebarStore(
		(state) => state.setPendingNavigation
	);
	const activeSubItem = useSidebarStore((state) => state.activeSubItem);
	const setActiveSubItem = useSidebarStore((state) => state.setActiveSubItem);

	// Local States
	const [searchFlag, setSearchFlag] = React.useState(false);
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	const [changesMade, setChangesMade] = useState(false);
	const [initialStorageTimeFeeData, setInitialStorageTimeFeeData] =
		React.useState([]);
	const [initialStorageSizeFeeData, setInitialStorageSizeFeeData] =
		React.useState({});
	// Graphql
	const userTypes = useQuery(USER_TYPE_FOR_LOCKER_STORAGE_FEES, {
		variables: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
		},
	});
	const lockerTypes = useQuery(LOCKER_TYPE_FOR_LOCKER_STORAGE_FEES);
	const doorSizes = useQuery(DOOR_SIZES_FOR_LOCKER_STORAGE_FEES);
	const [header, setheader] = useState("");
	const [storageSizeFee] = useLazyQuery(STORAGE_SIZE_FEE, {
		fetchPolicy: "no-cache",
	});
	const [storageTimeFees] = useLazyQuery(STORAGE_TIME_FEES, {
		fetchPolicy: "no-cache",
	});
	const [updateStorageTimeFee] = useMutation(UPDATE_STORAGE_TIME_FEE);
	const [updateStorageSizeFee] = useMutation(UPDATE_STORAGE_SIZE_FEE);
	console.log({ searchCriteria });
	const [isClicked, setIsClicked] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	// Event handlers
	const handleChangeCriteriaValue = (event) => {
		const { name, value } = event.target;
		setIsClicked(false);
		setChangesMade(true);
		// Dispatch the primary change
		dispatch(changeCriteriaValue({ name, value }));

		// Reset dependent fields based on the field being updated
		if (name === "lockerTypeId") {
			// Reset userTypeId and doorSizeId when lockerTypeId changes
			dispatch(changeCriteriaValue({ name: "userTypeId", value: "-1" }));
			dispatch(changeCriteriaValue({ name: "doorSizeId", value: "-1" }));
		} else if (name === "userTypeId") {
			// Reset doorSizeId when userTypeId changes
			dispatch(changeCriteriaValue({ name: "doorSizeId", value: "-1" }));
		}
	};

	const handleGetDoorSizeFee = () => {
		setSearchFlag(true);
		if (areAllFieldsNotMinusOne(searchCriteria)) {
			setIsClicked(true);
			setIsLoading(true); // Start loading

			const sizeFeePromise = storageSizeFee({ variables: searchCriteria });
			const timeFeePromise = storageTimeFees({ variables: searchCriteria });

			Promise.all([sizeFeePromise, timeFeePromise])
				.then(([sizeFeeData, timeFeeData]) => {
					// Process storageSizeFee data
					let tempStorageSizeFee = { ...sizeFeeData.data.storageSizeFee };
					delete tempStorageSizeFee.__typename;
					tempStorageSizeFee.operatorId = searchCriteria.operatorId;
					tempStorageSizeFee.lockerTypeId = searchCriteria.lockerTypeId;
					tempStorageSizeFee.userTypeId = searchCriteria.userTypeId;
					tempStorageSizeFee.doorSizeId = searchCriteria.doorSizeId;
					dispatch(setStorageSizeFeeData(tempStorageSizeFee));
					setInitialStorageSizeFeeData(tempStorageSizeFee);

					// Process storageTimeFees data
					let tempStorageTimeFee = [...timeFeeData.data.storageTimeFees];
					tempStorageTimeFee.forEach((element, key) => {
						let tempObj = { ...tempStorageTimeFee[key] };
						delete tempObj.__typename;
						tempObj.lockerTypeId = searchCriteria.lockerTypeId;
						tempObj.userTypeId = searchCriteria.userTypeId;
						tempObj.doorSizeId = searchCriteria.doorSizeId;
						tempStorageTimeFee[key] = tempObj;
					});
					dispatch(setStorageTimeFeeData(tempStorageTimeFee));
					setInitialStorageTimeFeeData(tempStorageTimeFee);

					// Update header
					setheader(`for
                    ${
											lockerTypeList.find(
												(x) => x.value === searchCriteria.lockerTypeId
											).name
										}
                    - 
                    ${
											userTypeList.find(
												(x) => x.value === searchCriteria.userTypeId
											).name
										} 
                    - 
                    ${
											doorSizesList.find(
												(x) => x.value === searchCriteria.doorSizeId
											).name
										} `);
				})
				.catch((e) => {
					console.log(e);
				})
				.finally(() => {
					setIsLoading(false); // End loading after both promises are resolved/rejected
				});
		} else {
			setSearchFlag(false);
			setIsClicked(false);
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete search criteria",
				message: "All fields are required.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		}
	};
	console.log({ isLoading });
	const handleAddStorageTimeFeeForm = () => {
		dispatch(
			addStorageTimeFeeForm({
				storageTimeFeeId: -1,
				lockerTypeId: searchCriteria.lockerTypeId,
				userTypeId: searchCriteria.userTypeId,
				doorSizeId: searchCriteria.doorSizeId,
				fee: "",
				hours: "",
			})
		);
		setChangesMade(true);
	};
	const handleChangeStorageFeeForm = (event) => {
		const { name, value, id } = event.target;
		dispatch(changeStorageTimeFeeForm({ name: name, value: value, id: id }));

		setChangesMade(true);
	};
	const handleChangeStorageFeeData = (event) => {
		const { name, value, id } = event.target;
		dispatch(changeStorageTimeFeeData({ name: name, value: value, id: id }));
		setChangesMade(true);
	};
	const handleChangeStorageSizeFeeData = (event) => {
		const { name, value } = event.target;
		dispatch(changeStorageSizeFeeData({ name: name, value: value }));
		setChangesMade(true);
	};
	const handleSaveChanges = () => {
		let combinedStorageTime = storageTimeFeeData.concat(storageTimeFeeForm);
		const storageSizeFeeObj = Object.values(storageSizeFeeData);
		const hasDuplicateStorageDuration = combinedStorageTime.some(
			(item, index, array) => {
				const targetValue = item["hours"];
				return array
					.slice(index + 1)
					.some(
						(otherItem) =>
							parseInt(otherItem["hours"]) === parseInt(targetValue)
					);
			}
		);
		const hasEmptyField = storageSizeFeeObj.every((value) => value !== "");

		if (hasDuplicateStorageDuration) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Duplicate data",
				message:
					"You have storage duration duplication entry. Please check your entry.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		} else if (!hasEmptyField || !areAllfieldsNotEmpty(combinedStorageTime)) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete entry",
				message:
					"You are trying to add empty required field. Please check your entry.",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		} else {
			updateStorageTimeFee({
				variables: {
					storageTimeFeeList: combinedStorageTime,
				},
			})
				.then(() => {
					storageTimeFees({ variables: searchCriteria })
						.then((data) => {
							let tempStorageTimeFee = [...data.data.storageTimeFees];
							data.data.storageTimeFees.forEach((element, key) => {
								let tempObj = { ...tempStorageTimeFee[key] };
								delete tempObj.__typename;
								tempObj.lockerTypeId = searchCriteria.lockerTypeId;
								tempObj.userTypeId = searchCriteria.userTypeId;
								tempObj.doorSizeId = searchCriteria.doorSizeId;
								tempStorageTimeFee[key] = tempObj;
							});
							dispatch(setStorageTimeFeeData(tempStorageTimeFee));
							setInitialStorageTimeFeeData(tempStorageTimeFee);
							dispatch(clearStorageTimeFeeForm());
						})
						.catch((e) => {
							console.log(e);
						});
				})
				.catch((e) => {
					console.log(e);
				});
			updateStorageSizeFee({ variables: storageSizeFeeData }).then(() => {
				storageSizeFee({ variables: searchCriteria })
					.then((data) => {
						let tempStorageSizeFee = { ...data.data.storageSizeFee };
						delete tempStorageSizeFee.__typename;
						tempStorageSizeFee.operatorId = searchCriteria.operatorId;
						tempStorageSizeFee.lockerTypeId = searchCriteria.lockerTypeId;
						tempStorageSizeFee.userTypeId = searchCriteria.userTypeId;
						tempStorageSizeFee.doorSizeId = searchCriteria.doorSizeId;
						dispatch(setStorageSizeFeeData(tempStorageSizeFee));
						setInitialStorageSizeFeeData(tempStorageSizeFee);
					})
					.catch((e) => console.log(e));
			});
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
				title: "Success",
				message: "Changes successfully saved",
				open: true,
				actions: (
					<div className="grid grid-cols-1">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2"}
						/>
					</div>
				),
			});
		}
	};
	const handleCancelChanges = () => {
		setValidation({
			open: false,
		});
		dispatch(setStorageSizeFeeData(initialStorageSizeFeeData));
		dispatch(setStorageTimeFeeData(initialStorageTimeFeeData));
		dispatch(clearStorageTimeFeeForm());
	};
	// Use Effects
	React.useEffect(() => {
		if (lockerTypes.data) {
			let tempVar = [];
			lockerTypes.data.lockerTypes.forEach((element) => {
				tempVar.push({
					value: element.lockerTypeId,
					name: element.lockerType,
				});
			});
			dispatch(getLockerTypeList(tempVar));
		}
	}, [lockerTypes.data]);
	React.useEffect(() => {
		if (userTypes.data) {
			let tempVar = [];
			userTypes.data.lockerUserTypes.forEach((element) => {
				tempVar.push({
					value: element.userTypeId,
					name: element.userType,
				});
			});
			dispatch(getUserTypeList(tempVar));
		}
	}, [userTypes.data]);
	React.useEffect(() => {
		if (doorSizes.data) {
			let tempVar = [];
			doorSizes.data.doorSizes.forEach((element) => {
				tempVar.push({
					value: element.doorSizeId,
					name: element.doorSize,
				});
			});
			dispatch(getDoorSizesList(tempVar));
		}
	}, [doorSizes.data]);

	useEffect(() => {
		if (pendingNavigation !== null) {
			if (changesMade) {
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
					title: `${Strings.popup_confirm_cancel_title}?`,
					message: Strings.popup_confirm_cancel_massage,
					open: true,
					actions: (
						<div className="flex justify-between gap-3">
							<Button
								onClick={() => {
									setValidation({ open: false });
									// window.location.reload();
									setPendingNavigation(null);
									setActiveSubItem(activeSubItem);
								}}
								value={"No"}
								className={"p-2 w-full"}
							/>
							<Button
								onClick={() => {
									navigate(pendingNavigation);
									setPendingNavigation(null);
								}}
								value={"Yes"}
								className={"p-2 w-full"}
							/>
						</div>
					),
				});
			} else {
				navigate(pendingNavigation);
				setPendingNavigation(null);
			}
		}
	}, [pendingNavigation, changesMade]);
	return (
		<ContentContainer containerTitle={"Locker Storage Fees"}>
			<div className="grid grid-cols-4 gap-2 w-2/3">
				<p className="my-auto">Locker Type:</p>
				<Select
					className={"col-span-2"}
					items={lockerTypeList}
					defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
					onChange={handleChangeCriteriaValue}
					name="lockerTypeId"
					value={searchCriteria.lockerTypeId}
				/>
				<div></div>
				<p className="my-auto">User Type:</p>
				<Select
					className={"col-span-2"}
					items={userTypeList}
					defaultOption={{ value: "-1", name: "-- Select User Type --" }}
					onChange={handleChangeCriteriaValue}
					name="userTypeId"
					value={searchCriteria.userTypeId}
				/>
				<div></div>
				<p className="my-auto">Door Size :</p>
				<Select
					className={"col-span-2"}
					items={doorSizesList}
					defaultOption={{ value: "-1", name: "-- Select Door Sizes --" }}
					onChange={handleChangeCriteriaValue}
					name="doorSizeId"
					value={searchCriteria.doorSizeId}
				/>
				<div className="grid grid-cols-2 w-1/2 gap-y-2">
					<div></div>
					<u
						className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
						onClick={() => {
							setSearchFlag(false);
							dispatch(
								changeCriteriaValue({ name: "doorSizeId", value: "-1" })
							);
							dispatch(
								changeCriteriaValue({ name: "userTypeId", value: "-1" })
							);
							dispatch(
								changeCriteriaValue({ name: "lockerTypeId", value: "-1" })
							);
						}}
					>
						<i className="fas fa-undo my-auto"></i>
						<p className="ml-1">Reset</p>
					</u>
				</div>
				<div></div>
				<div className="col-span-1 flex mt-2">
					<Button
						value={"Search"}
						className={"p-2 w-full"}
						onClick={handleGetDoorSizeFee}
					/>
				</div>
			</div>
			{isClicked &&
				(isLoading ? (
					<LoadingComponent />
				) : (
					areAllFieldsNotMinusOne(searchCriteria) &&
					searchFlag && (
						<>
							<div className="bg-primary-primaryYellow w-2/3 mt-4 p-4 text-center border-secondary-buttonHeaderGray border-2">
								<p className="font-bold text-xl">STORAGE FEES</p>
								<p>{header}</p>
							</div>
							<StorageFeeTable
								data={storageTimeFeeData}
								handleAddForm={handleAddStorageTimeFeeForm}
								addedData={storageTimeFeeForm}
								handleChangeForm={handleChangeStorageFeeForm}
								handleChangeData={handleChangeStorageFeeData}
								disabled={
									accessPermission.lockerStorageFees === "1" ||
									accessPermission.lockerStorageFees === 1
								}
							/>
							<OverstayCharge
								disabled={
									accessPermission.lockerStorageFees === "1" ||
									accessPermission.lockerStorageFees === 1
								}
								header={header}
								data={storageSizeFeeData}
								handleChange={handleChangeStorageSizeFeeData}
							/>
							<MaxOverstayCharge
								disabled={
									accessPermission.lockerStorageFees === "1" ||
									accessPermission.lockerStorageFees === 1
								}
								header={header}
								data={storageSizeFeeData}
								handleChange={handleChangeStorageSizeFeeData}
							/>
							{/* {storageTimeFeeForm.length > 0 && } */}

							{changesMade && (
								<div className="w-1/2 grid grid-cols-2 gap-4 my-4">
									<Button
										disabled={
											accessPermission.lockerStorageFees === 1 ||
											accessPermission.lockerStorageFees === "1"
										}
										className={`p-2 ${
											accessPermission.lockerStorageFees === 1 ||
											accessPermission.lockerStorageFees === "1"
												? "hidden"
												: ""
										}`}
										value="Cancel"
										onClick={() => {
											setValidation({
												icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
												title: "Cancel changes",
												message: "Are you sure you want to cancel changes?",
												open: true,
												actions: (
													<div className="grid grid-cols-2 gap-2">
														<Button
															onClick={() => setValidation({ open: false })}
															value={"No"}
															className={"p-2"}
														/>
														<Button
															onClick={handleCancelChanges}
															value={"Yes"}
															className={"p-2"}
														/>
													</div>
												),
											});
										}}
									/>
									<Button
										disabled={
											accessPermission.lockerStorageFees === 1 ||
											accessPermission.lockerStorageFees === "1"
										}
										className={`p-2 ${
											accessPermission.lockerStorageFees === 1 ||
											accessPermission.lockerStorageFees === "1"
												? "hidden"
												: ""
										}`}
										value="Save Changes"
										onClick={() => {
											setValidation({
												icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
												title: "Save changes",
												message: "Are you sure you want to save changes?",
												open: true,
												actions: (
													<div className="grid grid-cols-2 gap-2">
														<Button
															onClick={() => setValidation({ open: false })}
															value={"No"}
															className={"p-2"}
														/>
														<Button
															onClick={handleSaveChanges}
															value={"Yes"}
															className={"p-2"}
														/>
													</div>
												),
											});
										}}
									/>
								</div>
							)}
						</>
					)
				))}
			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</ContentContainer>
	);
}
